import { useQueries } from '@tanstack/react-query';

import { useServicesQuery, servicesApi } from '@/services/api';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';
import { shouldRetry } from '@/services/api/ts-rest';

const SYSTEM_TRIGGER_NAMES = new Set([
  'password_reset',
  'team_member_invite',
  'invite_existing_user',
  'signup_verification',
  'signup_with_existing_account',
  'copilot_message',
]);

export function useSendTransactionalStep(enabled = true, workspaceIdOverride?: number) {
  const urlWorkspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  const workspaceId = workspaceIdOverride ?? urlWorkspaceId;

  const { data, isLoading: isLoadingMessages } = useServicesQuery(
    'getTransactionalMessages',
    { params: { environment_id: workspaceId }, query: {} },
    { enabled: enabled && workspaceId > 0 },
  );

  const messages = data?.transactional_messages ?? [];

  const userMessages = messages.filter((m) => m.trigger_name == null || !SYSTEM_TRIGGER_NAMES.has(m.trigger_name));

  const metricsQueries = useQueries({
    queries: userMessages.map((m) => ({
      queryKey: [
        'getTransactionalMessageMetrics',
        { params: { environment_id: workspaceId, transactional_message_id: m.id } },
      ],
      queryFn: () =>
        servicesApi.getTransactionalMessageMetrics({
          params: { environment_id: workspaceId, transactional_message_id: m.id },
        }),
      enabled: enabled && workspaceId > 0 && userMessages.length > 0,
      retry: shouldRetry,
    })),
  });

  const isLoadingMetrics = metricsQueries.some((q) => q.isLoading);
  const isLoading = isLoadingMessages || isLoadingMetrics;
  const hasSentTransactional = metricsQueries.some((q) => (q.data?.metric.total_sent ?? 0) > 0);

  return { hasSentTransactional, isLoading };
}
